import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql, navigate } from "gatsby"

import {
  BorderRadius,
  Color,
  Spacing,
  Typography,
} from "@persona-id/design-tokens"
import Spacer from "@persona-id/design-system/components/Spacer"

const NavigationLeftAcademy = ({
  onNavLinkClick,
}: {
  onNavLinkClick?: () => void
}) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulAcademyCourseList(
        filter: { internalName: { eq: "All Academy Courses" } }
      ) {
        nodes {
          academyCourses {
            id
            title
            slug
          }
        }
      }
    }
  `)

  return (
    <>
      <NavigationLeftSubheading>Courses</NavigationLeftSubheading>
      {data.allContentfulAcademyCourseList.nodes[0].academyCourses.map(
        course => (
          <NavigationLeftLink
            key={`navigation-left-course-${course.id}`}
            onClick={() => {
              navigate(`/academy/${course.slug}`)
              if (onNavLinkClick) onNavLinkClick()
            }}
          >
            {course.title}
          </NavigationLeftLink>
        )
      )}
      <Spacer height={2} />
      <NavigationLeftSubheading>More</NavigationLeftSubheading>
      <NavigationLeftLink
        onClick={() => {
          navigate("/academy#course-certifications")
          if (onNavLinkClick) onNavLinkClick()
        }}
      >
        Course Certifications
      </NavigationLeftLink>
      <NavigationLeftLink
        onClick={() => {
          navigate("/academy#experts-program")
          if (onNavLinkClick) onNavLinkClick()
        }}
      >
        Persona Developer Partners
      </NavigationLeftLink>
    </>
  )
}

const NavigationLeftSubheading = styled.h2`
  ${Typography.TextLargeBold};
  margin: 0px 0px ${Spacing[1]} 0px;
`

const NavigationLeftLink = styled.div`
  ${Typography.TextMedium};
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[2]};
  align-items: center;
  padding: ${Spacing[1]};
  border-radius: ${BorderRadius.Sm};
  cursor: pointer;

  :hover {
    color: ${Color.CorePurple800};
    background-color: ${Color.CorePurple100};
  }
`

export default NavigationLeftAcademy
